import { Building } from "lucide-react";
import { Registration } from "@/utils/types/NPS/Stepper/GetRegistrationDetils";

const AccountDetails: React.FC<{
  registrationDetails: Registration | null;
}> = ({ registrationDetails }) => {
  if (!registrationDetails) {
    return <div>Loading...</div>;
  }
  return (
    <div className="rounded-xl border bg-card shadow-sm">
      <div className="border-b p-4">
        <h2 className="flex items-center gap-2 text-lg font-semibold text-secondary">
          <Building className="h-5 w-5 text-primary" />
          Account Details
        </h2>
      </div>

      <div className="space-y-3 p-4">
        {/* ROW */}
        <div className="flex items-center justify-between rounded-lg bg-muted/30 p-3">
          <span className="text-sm text-muted-foreground">PRAN Number</span>
          <span className="font-mono font-bold text-secondary">
            {registrationDetails?.initialDetails.pranNumber}
          </span>
        </div>

        <div className="flex items-center justify-between rounded-lg bg-muted/30 p-3">
          <span className="text-sm text-muted-foreground">Status</span>
          <span className="rounded-full border border-green-200 bg-green-50 px-3 py-1 text-xs text-green-700">
            {registrationDetails?.status}
          </span>
        </div>

        {/* <div className="flex items-center justify-between rounded-lg bg-muted/30 p-3">
          <span className="text-sm text-muted-foreground">Tier 1 Balance</span>
          <span className="font-mono font-bold text-secondary">₹{registrationDetails.schemeDtls.tier1Balance}</span>
        </div>

        <div className="flex items-center justify-between rounded-lg bg-muted/30 p-3">
          <span className="text-sm text-muted-foreground">Tier 2 Balance</span>
          <span className="font-mono font-bold text-secondary">₹{registrationDetails.schemeDtls.tier2Balance}</span>
        </div> */}

        <div className="flex items-center justify-between rounded-lg bg-muted/30 p-3">
          <span className="text-sm text-muted-foreground">PFM</span>
          <span className="text-sm font-medium">
            {registrationDetails?.schemeDtls?.[0]?.schemeList?.[0]?.pfmName ??
              "-"}
          </span>
        </div>

        <div className="flex items-center justify-between rounded-lg bg-muted/30 p-3">
          <span className="text-sm text-muted-foreground">
            Investment Choice
          </span>
          <span className="rounded-full border bg-background px-3 py-1 text-xs text-secondary">
            {registrationDetails?.schemeDtls?.[0]?.schPrefChoice ?? "-"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
